export { default } from './LockPrompt';
